import type { Variants } from '@/common';
import { type MaybeRefOrGetter, toValue } from 'vue';
export const closeInjectionKey = Symbol() as InjectionKey<{
    show: MaybeRefOrGetter<boolean>;
    close?: () => void;
    disabled?: MaybeRefOrGetter<boolean>;
    label?: MaybeRefOrGetter<string | undefined>;
    variant?: MaybeRefOrGetter<Variants | undefined>;
    bind?: MaybeRefOrGetter<Record<string, any>>;
}>;

export const useClose = () => {
    const injected = inject(closeInjectionKey, undefined);
    const show = eagerComputed(() => toValue(injected?.show) ?? false);
    const close =
        injected?.close ??
        (() => {
            console.log('Close handler not available in parent.');
        });
    const disabled = eagerComputed(() => toValue(injected?.disabled) ?? false);
    const label = eagerComputed(() => toValue(injected?.label) ?? 'Close');
    const variant = eagerComputed(() => toValue(injected?.variant) ?? 'primary');
    const bind = eagerComputed(() => toValue(injected?.bind) ?? { class: 'btn-outline' });

    return { show, close, label, variant, bind, disabled };
};
